document.addEventListener("DOMContentLoaded", function () {

  // Responsive product titles
  function handleResponsiveProductTitles() {
    var titles = document.querySelectorAll(".shop-product-title[data-font-size][data-mobile-font-size]");
    function adjust() {
      var mob = window.innerWidth <= 767;
      titles.forEach(function (t) {
        t.style.setProperty("font-size", t.getAttribute(mob ? "data-mobile-font-size" : "data-font-size") + "px", "important");
      });
    }
    adjust();
    if (!window.titleResizeHandlerAdded) { window.addEventListener("resize", adjust); window.titleResizeHandlerAdded = true; }
  }
  handleResponsiveProductTitles();

  // FAQ accordions
  document.querySelectorAll(".product-faq").forEach(function (faqContainer) {
    if (!faqContainer.id) return;
    var items = faqContainer.querySelectorAll(".faq-item");
    var inner = faqContainer.querySelector(".faq-container");
    var isAcc = inner && inner.getAttribute("data-accordion") === "true";
    items.forEach(function (item) {
      var q = item.querySelector(".faq-question");
      if (!q || q.hasAttribute("data-click-listener-added")) return;
      q.setAttribute("data-click-listener-added", "true");
      q.addEventListener("click", function () {
        if (isAcc && !item.classList.contains("active"))
          items.forEach(function (o) { o.classList.remove("active"); });
        item.classList.toggle("active");
      });
    });
  });

  // Read more / read less
  document.querySelectorAll(".shop-read-more").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var p = this.closest(".shop-product-description");
      p.querySelector(".shop-truncated-description").style.display = "none";
      p.querySelector(".shop-full-description").style.display = "block";
    });
  });
  document.querySelectorAll(".shop-read-less").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var p = this.closest(".shop-product-description");
      p.querySelector(".shop-truncated-description").style.display = "block";
      p.querySelector(".shop-full-description").style.display = "none";
    });
  });

});
